import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import moment from 'moment'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const History = () => {
  toast.configure()
  const [values, setValues] = useState([])
  const [modifiedBy, setModifiedBy] = useState()
  const [modifiedDate, setModifiedDate] = useState()
  const params = useParams()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  const token = localStorage.getItem('token')

  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchFormData',
        {
          id: params.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        setValues(response.data.historyData.historyData)
        setModifiedBy(response.data.historyData.modified_by)
        setModifiedDate(response.data.historyData.modified_date)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          logout()
        }
      })
  }
  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id])

  return (
    <div className="container">
      <div className="row d-flex align-items-center">
        <span className="col-sm-2" style={{ fontWeight: 600 }}>
          Last modified by :{' '}
        </span>{' '}
        {modifiedBy}
      </div>
      <div className="row d-flex align-items-center mb-3">
        <span
          className="col-sm-2"
          style={{ marginLeft: '0.5rem', fontWeight: 600 }}
        >
          Last modified date :{' '}
        </span>{' '}
        {modifiedDate
          ? moment(modifiedDate.slice(0, 10)).format('DD-MM-YYYY') +
            ' - ' +
            new Date(
              '1970-01-01T' + modifiedDate.slice(11, 19) + 'Z',
            ).toLocaleTimeString('en-US', {
              timeZone: 'UTC',
              hour12: true,
              hour: 'numeric',
              minute: 'numeric',
            })
          : ''}
      </div>

      <div className="row" style={{ marginLeft: '0rem' }}>
        {values ? (
          values.map((i, index) => {
            return (
              <div className="col-md-4 col-lg-4 col-12" key={index}>
                <div className="card" style={{ width: '20rem' }}>
                  <div className="card-body">
                    <h5 className="card-title">{i.interview_round}</h5>
                    <p className="card-text">
                      Interviewer Feedback : <br /> {i.interview_feedback}
                    </p>
                  </div>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      <div className="row">
                        <div className="col-12">Interview Date : </div>
                        <div className="col-12">
                          {i.interview_date === null || i.interview_date === ''
                            ? ''
                            : moment(i.interview_date).format('DD-MM-YYYY')}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item">
                      {' '}
                      <div className="row">
                        <div className="col-12">Interview Time : </div>
                        <div className="col-12">
                          {new Date(
                            '1970-01-01T' + i.interview_time + 'Z',
                          ).toLocaleTimeString('en-US', {
                            timeZone: 'UTC',
                            hour12: true,
                            hour: 'numeric',
                            minute: 'numeric',
                          })}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item">
                      {' '}
                      <div className="row">
                        <div className="col-12">Interviewer Name : </div>
                        <div className="col-12">{i.interviewer_name}</div>
                      </div>
                    </li>
                    <li className="list-group-item">
                      {' '}
                      <div className="row">
                        <div className="col-12">Remarks by HR : </div>
                        <div className="col-12">{i.remarks_hr}</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )
          })
        ) : (
          <h6 className="text-center mt-5">No history available yet!!</h6>
        )}
      </div>
    </div>
  )
}
